<template>
  <div class="esp-index-wrap">
    <!-- 上部：header区域 -->
    <div class="esp-header">
      <esp-header
        ref="header"
        :is-collapsed="isCollapse"
        @toggle-collapse="toggleSidebar"
        @selected-after="clickMenu"
      ></esp-header>
    </div>

    <!-- 下部：main区域 -->
    <div class="esp-main">
      <!-- 左侧边栏 -->
      <div class="esp-aside" :class="{ 'collapsed': isCollapse }">
        <esp-aside @selected-after="clickMenu"></esp-aside>
      </div>

      <!-- 右侧内容区 -->
      <div class="esp-content" :class="{ 'collapsed': isCollapse }">
        <div class="esp-body">
          <div class="esp-iframe-box">
            <router-view :isMenuCollapsed="isCollapse"></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EspAside from "@/pages/layout/v2/espAside";
import EspHeader from "@/pages/layout/v2/espHeader";
import * as cache from "@/utils/cache";
import * as auth from "@/api/platform/auth";
export default {
  name: "EspIndex",
  components: { EspAside, EspHeader },
  data() {
    return {
      isCollapse: false,
      formData: {
        pk_user: cache.getUserInfo().pk,
        osType: "web",
        manufacturer: this.getSimpleOS(),
      },
    };
  },
  methods: {
    toggleSidebar() {
      this.isCollapse = !this.isCollapse;
    },
    clickMenu(d) {
      // 处理菜单点击逻辑
    },
    saveUserPlatform() {
      auth.saveUserPlatform(this.formData).then(result => {
      }).catch(error => {
      });
    },
    getSimpleOS() {
      const platform = navigator.platform;
      if (platform.includes('Win')) return 'Windows';
      if (platform.includes('Mac')) return 'MacOS';
      if (platform.includes('Linux')) return 'Linux';
      if (platform.includes('iPhone') || platform.includes('iPad')) return 'iOS';
      if (platform.includes('Android')) return 'Android';
      return 'Unknown OS';
    }
},
  created() {
    this.saveUserPlatform();
  },
};
</script>

<style scoped lang="less">
.esp-index-wrap {
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-width: 1500px;
}

.esp-header {
  height: 8vh;
  min-height: 60px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
  position: relative; /* 确保header在最上层 */
}

.esp-main {
  display: flex;
  width: 100%;
  height: 92vh; /* 调整为100% - header高度 */
  overflow: hidden;
  position: relative;
}

.esp-aside {
  width: 260px; /* 固定宽度 */
  background-color: #f8f9fa;
  border-right: 1px solid #e9ecef;
  overflow-y: auto;
  transition: all 0.3s ease;
  flex-shrink: 0; /* 防止缩小 */

  &.collapsed {
    transform: translateX(-260px); /* 向左移出屏幕 */
    width: 0;
    border-right: none;
  }
}

.esp-content {
  flex: 1;
  overflow: hidden;
  transition: all 0.3s ease;

  &.collapsed {
    margin-left: 0;
  }

  &:not(.collapsed) {
    width: calc(100% - 210px); /* 总宽度减去菜单宽度 */
  }
}

.esp-body {
  height: 100%;
}

.esp-iframe-box {
  width: 100%;
  height: 100%;
  background-color: #eff3f1;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/layout/v2/espIndex.vue